import {
  formatDateMMddYYYY,
  MetricProgressBar,
  toProgressSegments,
} from '../utils/utils';
import {
  ProgressPortraitMetrics,
  WbsAssessment,
} from '../model/ProgressPortrait';
import { CellData, ProgressBar } from './ProgressBar';
import { CellTooltip, TooltipItem } from './CellTooltip';

const wbsExtractor = (progressPortraitMetrics: ProgressPortraitMetrics) =>
  progressPortraitMetrics.wbss;

const toCellData = (wbssData: WbsAssessment): CellData => {
  const tooltip = <WellbeingScoreTooltip wbs={wbssData} />;

  if (wbssData.total_Stress__c >= 43 && wbssData.total_Stress__c <= 75) {
    return {
      label: 'Average',
      level: 'high',
      tooltip,
    };
  }
  if (wbssData.total_Stress__c >= 31 && wbssData.total_Stress__c <= 42) {
    return {
      label: 'Below Average',
      level: 'medium',
      tooltip,
    };
  }
  if (wbssData.total_Stress__c >= 15 && wbssData.total_Stress__c <= 30) {
    return {
      label: 'Clinically Significant',
      level: 'low',
      tooltip,
    };
  }
  return {
    label: 'N/A',
    level: 'NA',
    tooltip,
  };
};

const sortCellComparator = (
  point1: WbsAssessment,
  point2: WbsAssessment,
): number =>
  point1.assessment_Date__c.valueOf() - point2.assessment_Date__c.valueOf();

export const WellbeingScaleMetric = ({
  progressPortraitMetrics,
}: MetricProgressBar) => {
  const segments = toProgressSegments(
    progressPortraitMetrics,
    wbsExtractor,
    toCellData,
    sortCellComparator,
  );
  return <ProgressBar segments={segments} />;
};

const WellbeingScoreTooltip = ({ wbs }: { wbs: WbsAssessment }) => {
  let text = 'N/A';

  if (wbs.total_Stress__c >= 43 && wbs.total_Stress__c <= 75) {
    text = 'Average';
  } else if (wbs.total_Stress__c >= 31 && wbs.total_Stress__c <= 42) {
    text = 'Below Average';
  } else if (wbs.total_Stress__c >= 15 && wbs.total_Stress__c <= 30) {
    text = 'Clinically Significant';
  }

  const info: TooltipItem[] = [
    {
      label: 'Wellbeing Scale Date:',
      value: formatDateMMddYYYY(wbs.assessment_Date__c),
    },
    {
      label: 'Wellbeing Scale Type:',
      value: wbs.well_being_Scale_Type__c,
    },
    {
      label: 'Wellbeing Score:',
      value: `${wbs.total_Stress__c} (${text})`,
    },
    {
      label: 'Respondent:',
      value: wbs.name_Of_Respondent__c,
    },
  ];
  return <CellTooltip info={info} />;
};
